module.exports = (__webpack_require__("xDzS"))(1);


//////////////////
// WEBPACK FOOTER
// delegated ../node_modules/webpack/buildin/global.js from dll-reference common_library
// module id = DuR2
// module chunks = 16 17 18 19